
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CasisDealerMultiFilter extends Vue {
    @Prop({ type: Array, default: () => [] }) value!: number[];
    @Prop({ type: Boolean, default: false }) locked!: boolean;
    changeTimer: any = null;

    get loading() { return this.$store.state.dealer.loading; }
    get dealers() {
        return this.$store.state.dealer.activeList.map((dealer: any) => ({
            ...dealer,
            display_name: `${dealer.name}${dealer.location ? ' - ' + dealer.location : ''}`,
        }));
    }
    get allDealerIds() { return this.dealers.map((dealer: any) => dealer.id); }
    get allDealersSelected() {
        return this.allDealerIds.length > 0 && this.allDealerIds.every((id: number) => this.value.includes(id));
    }
    get showAllDealersLabel() {
        return this.allDealerIds.length > 1 && this.allDealersSelected;
    }
    get someDealersSelected() {
        return this.value.length > 0 && !this.allDealersSelected;
    }

    async mounted() {
        if (!this.$store.state.dealer.activeList.length) {
            await this.$store.dispatch({ type: 'dealer/getAllActive' });
        }
    }

    change(value: number[]) {
        if (this.locked) return;
        this.$emit('input', value || []);
        clearTimeout(this.changeTimer);
        this.changeTimer = setTimeout(() => this.$emit('change'), 350);
    }

    toggleAll() {
        if (this.locked) return;
        this.change(this.allDealersSelected ? [] : [...this.allDealerIds]);
    }
}
